export default __webpack_public_path__ + "static/media/MonicaStuart.ae4b0295.jpeg";